'use strict';

Object.defineProperty(exports, '__esModule', {
    value: true
});
exports['default'] = {
    BLOCK: 'block',
    IMAGE: 'image',
    BOX: 'box',
    CONTAINER: 'container',
    RESIZABLE_HANDLE: 'resize',
    TREE_NODE: 'treeNode'
};
module.exports = exports['default'];


/*****************
 ** WEBPACK FOOTER
 ** ./~/react-designer-core/lib/util/ItemTypes.js
 ** module id = 182
 ** module chunks = 0
 **/